import React from 'react';

const Logo = ({ className, size = 32, color = '#2563EB' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="8"
        cy="20"
        r="4.5"
        fill="white"
        stroke={color}
        strokeWidth="2.25"
      />
      <circle
        cx="32"
        cy="20"
        r="4.5"
        fill="white"
        stroke={color}
        strokeWidth="2.25"
      />

      <path
        d="M12.4 14.5H24.4"
        stroke={color}
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M22.4 11.9L27.4 14.5L22.4 17.1"
        stroke={color}
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18.7" cy="14.5" r="1.45" fill={color} />

      <path
        d="M27.6 25.5H15.6"
        stroke={color}
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      <path
        d="M17.6 22.9L12.6 25.5L17.6 28.1"
        stroke={color}
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="21.3" cy="25.5" r="1.45" fill={color} fillOpacity="0.55" />
    </svg>
  );
};

export default Logo;
